import { getAppData } from '../../lib/api/common';
import {
	getSectors,
	getSectorBySlug
} from '../../lib/api/sectors';

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'
import PageBuilder from '../../components/content/PageBuilder'
import PageHeaderBasic from '../../components/content/page/PageHeaderBasic'
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";


export type SectorProps = {
	sector: any // sector entry
	sectors: any // sectors index for breadcrumb
	app: any
}

export async function getStaticPaths() {

	// Only the first page is statically generated
	const data: any = await getSectors();

	const paths = data.entries && data.entries.length > 0 ? data.entries.map((entry: any) => {
		return {
			params: {
				slug: entry.slug,
			},
		}
	}) : []

	return {
		paths,
		fallback: 'blocking',
	}
}

export async function getStaticProps(context: any) {

	const slug: string = context?.params?.slug

	const app: any = await getAppData();
	const data: any = await getSectorBySlug(
		slug,
		context.preview ? context.previewData?.token : undefined
	);

	if (!data.sector) {
		return {
			notFound: true,
			revalidate: revalidateSeconds()
		}
	}

	return {
		props: {
			app: app ? app : null,
			sector: data.sector ? data.sector : null, // Current sector
			sectors: data.sectors ? data.sectors : null, // Sectors index
		},
		revalidate: revalidateSeconds()
	};
}

export default function Sector(props: SectorProps) {

	const { sector, sectors, app } = props

	const links: any = [
		{
			id: sectors.id,
			title: sectors.title,
			uri: sectors.uri,
		},
		{
			id: sector.id,
			title: sector.title,
			uri: null
		}
	]


	return (
		<>
			<SeoMaticHead seo={sector.seo} />
			<Layout
				key={sector.id}
				appData={app}
				subHeader={links}
			>
				<>
					<PageHeaderBasic
						block={sector?.pageHeader.length > 0 ? sector.pageHeader[0] : null}
						forceNoBackground={true}
					/>
					<PageBuilder contentBlocks={sector.pageBuilder} />
				</>
			</Layout>
		</>
	)
}

